import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { reconcileConfigs, reconcileReviewConfigs } from '../business/configManager/ConfigManager';
import createStore from '../redux/store';
import { executeDropInPaymentsCommands } from '../redux/command/command.action';
import { saveConfigs } from '../redux/config/config.slice';
import { saveReviewData } from '../redux/review/review.slice';
import { saveCartInfo } from '../redux/cart/cart.slice';
import { initialState as cartInitialState } from '../redux/cart/cart.slice';
var store;
var shouldRemergeConfigs = false;
var setInitialTaxInfo = false;

/**
 * Store builder utility to add more utities on redux store (eg. merge configs, help mock states)
 */
export var storeBuilder = function storeBuilder() {
  return {
    getStore: function getStore(_ref) {
      var config = _ref.config,
        review = _ref.review,
        taxInfo = _ref.taxInfo,
        additionalState = _ref.additionalState,
        _ref$testMode = _ref.testMode,
        testMode = _ref$testMode === void 0 ? false : _ref$testMode;
      if (!testMode && store) {
        if (shouldRemergeConfigs) {
          store.dispatch(saveConfigs(reconcileConfigs(_objectSpread(_objectSpread({}, config), {}, {
            authorization: _objectSpread(_objectSpread({}, config.authorization), {}, {
              bffKey: config.authorization.bffKey || ''
            })
          }))));
          store.dispatch(saveReviewData(reconcileReviewConfigs(review)));
          shouldRemergeConfigs = false;
        }
        if (setInitialTaxInfo && taxInfo) {
          store.dispatch(saveCartInfo({
            taxInfo: taxInfo
          }));
          setInitialTaxInfo = false;
        }
        return store;
      }
      var initialState = _objectSpread({
        config: reconcileConfigs(_objectSpread(_objectSpread({}, config), {}, {
          authorization: _objectSpread(_objectSpread({}, config.authorization), {}, {
            bffKey: config.authorization.bffKey || ''
          })
        })),
        review: reconcileReviewConfigs(review),
        cart: _objectSpread(_objectSpread(_objectSpread({}, cartInitialState), !!taxInfo ? {
          taxInfo: taxInfo
        } : {}), config.recurlyCart)
      }, additionalState);
      store = createStore(initialState);
      return store;
    },
    sendCommands: function sendCommands(commands) {
      if (store) {
        store.dispatch(executeDropInPaymentsCommands(commands));
      }
    },
    resetStore: function resetStore() {
      store.dispatch({
        type: 'RESET_STORE'
      });
      shouldRemergeConfigs = true;
      setInitialTaxInfo = true;
    }
  };
};

/**
 * Clears Store by setting it to null
 */
export var clearStore = function clearStore() {
  store = null;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/utils/ReduxStoreUtil.js
// module id = 4679
// module chunks = 11